// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refereeValidationPage h3,
.refereeValidationPage p {
  color: #262626;
  font-weight: normal;
  opacity: 0.65;
  font-size: 13px;
}
.refereeValidationPage h3 {
  text-transform: uppercase;
  margin-top: 16px;
  margin-bottom: 4px;
}
.refereeValidationPage .pageBody .borderContent {
  margin-top: 0;
}
.refereeValidationPage .pageBody .borderContent ul {
  margin-top: 4px;
  margin-bottom: 20px;
}
.refereeValidationPage .pageBody .borderContent button {
  float: none;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/refereeValidation/RefereeValidation.less"],"names":[],"mappings":"AAEA;;EAEE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AADF;AAJA;EASE,yBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AATA;EAgBG,aAAA;AAJH;AAZA;EAmBI,eAAA;EACA,mBAAA;AAJJ;AAhBA;EAwBI,WAAA;AALJ","sourcesContent":["@import (reference) '../../constants.less';\n\n.refereeValidationPage {\n\th3, p {\n\t\tcolor: @labelGrey;\n\t\tfont-weight: normal;\n\t\topacity: 0.65;\n\t\tfont-size: 13px;\n\t}\n\n\th3 {\n\t\ttext-transform: uppercase;\n\t\tmargin-top: 16px;\n\t\tmargin-bottom: 4px;\n\t}\n\n\t.pageBody {\n\t\t.borderContent {\n\t\t\tmargin-top: 0;\n\n\t\t\tul {\n\t\t\t\tmargin-top: 4px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\n\t\t\tbutton {\n\t\t\t\tfloat: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
